import { useContext } from 'react';
import FeatureFlagsContext from 'contexts/FeatureFlags/FeatureFlagsContext';
import { getFlags } from './utils';

export default function useFeatureFlags(requestedFlags) {
    const { state, actions } = useContext(FeatureFlagsContext);

    const usedFlags = getFlags(requestedFlags, state?.featureFlags || {});

    return [usedFlags, actions];
}
